import React from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import {Grid} from "@material-ui/core";
import {useHtmlComponentGql} from "../../../../hooks/useHtmlComponent";
import CustomRichTextFromMarkdown from "../../../widget/text/CustomRichTextFromMarkdown";
import PropTypes from "prop-types";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles(() => ({
    footer: {
        textAlign: "center"
    }
}));

const query = `
    elementsCollection{
        items{
            ... on TextColumnsWithImage{
                title
                description
            }
        }
    }
`;

const TutorialFooter = ({componentId}) => {
    const classes = useStyles();
    const {componentData, componentDataLoading} = useHtmlComponentGql(componentId, query);

    return (
        <Grid
            container
            alignItems="center"
            justify="center"
        >
            <Grid
                item
                className={classes.footer}
            >
                {!componentDataLoading ? (
                    <CustomRichTextFromMarkdown
                        markdownString={componentData?.elementsCollection?.items[0]?.description}
                    />
                ) : (
                    <Skeleton
                        variant="rect"
                        height={60}
                    />
                )
                }
            </Grid>
        </Grid>
    );
};

TutorialFooter.propTypes = {
    componentId: PropTypes.any
};

export default TutorialFooter;
